import { useDiagramTool } from "../components/LanguageDropdown";
import { useDoc } from "./useDoc";

export function useDiagramTypeTool() {
  const diagram = useDiagramTool((s) => s.diagramTool);
  const diagramTool = useDoc((s) => s.meta?.diagramTool as string);
  const tool = diagram ?? diagramTool;
  if (typeof tool !== "string" || !tool) return ["flowchart-fun", false];
  const useKrokiChartView = tool != "flowchart-fun";
  return [tool, useKrokiChartView];
}
